import { combineReducers } from 'redux';
import loginReducers from './loginReducers';
import addUserReducers from './addUserReducers';
import viewUsersReducers from './viewUsersReducers';
import updateProfileReducer from './updateProfileReducer';

export default combineReducers({
  login: loginReducers,
  viewUsers:viewUsersReducers,
  addUser: addUserReducers,
  profile: updateProfileReducer,
});
